// extracted by mini-css-extract-plugin
module.exports = {"card":"_3MZR8 _2s-6N","big":"_16JQ6","subText":"_1OK0n"};